import { useTranslation } from 'react-i18next';
import { Layers, Folder } from 'lucide-react';
import styles from './GroupSelector.module.css';

export interface GroupSelectorGroup {
  id: string;
  name: string;
  icon: string;
  color: string;
}

interface GroupSelectorProps {
  groups: GroupSelectorGroup[];
  selectedGroupId: string | null;
  onSelectGroup: (groupId: string | null) => void;
}

export const GroupSelector = ({ groups, selectedGroupId, onSelectGroup }: GroupSelectorProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={`${styles.chip} ${!selectedGroupId ? styles.selected : ''}`}
        onClick={() => onSelectGroup(null)}
      >
        <Layers size={16} />
        <span>{t('filter.allGroups', 'All groups')}</span>
      </button>
      {groups.map((g) => {
        const isSelected = selectedGroupId === g.id;
        return (
          <button
            key={g.id}
            type="button"
            className={`${styles.chip} ${isSelected ? styles.selected : ''}`}
            onClick={() => onSelectGroup(g.id)}
            style={!isSelected && g.color ? { ['--chip-color' as string]: g.color } : undefined}
          >
            <Folder size={16} />
            <span>{g.name}</span>
          </button>
        );
      })}
    </div>
  );
};
